module.exports = __webpack_public_path__ + "img/5737820.png";